// Activity signal service: detects pointer/keyboard interaction and sends a
// heartbeat so the backend cancels any pending absence check.

import axios from '@/api/axios'
import { getAccessToken } from '@/api/axios'

const ACTIVITY_DEBOUNCE_MS = 5_000

let timeoutId: ReturnType<typeof setTimeout> | null = null
let isListening = false

function sendActivitySignal(): void {
  const token = getAccessToken()
  if (!token) {
    return
  }
  axios.post('/api/v1/auth/heartbeat').catch(() => {
    // Fire-and-forget; the backend tolerates silent failures.
  })
}

function onActivity(): void {
  if (timeoutId !== null) {
    return
  }

  timeoutId = setTimeout(() => {
    timeoutId = null
    sendActivitySignal()
  }, ACTIVITY_DEBOUNCE_MS)
}

export function startActivityTracking(): () => void {
  if (isListening) {
    return stopActivityTracking
  }

  isListening = true
  window.addEventListener('pointerdown', onActivity, { passive: true, capture: true })
  window.addEventListener('keydown', onActivity, { passive: true, capture: true })

  return stopActivityTracking
}

export function stopActivityTracking(): void {
  if (timeoutId !== null) {
    clearTimeout(timeoutId)
    timeoutId = null
  }

  if (!isListening) {
    return
  }

  window.removeEventListener('pointerdown', onActivity, { capture: true })
  window.removeEventListener('keydown', onActivity, { capture: true })
  isListening = false
}
